<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <form
        class="needs-validation"
        @submit.prevent="checkForm()">
        <div class="card">
          <div class="card-header">
            <h3
              class="mb-0"
              style="text-transform: capitalize">
              Basic Profile
            </h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <base-input label="Select Service Category">
                  <el-select v-model="vendor.serviceCategoryId">
                    <el-option
                      v-for="(item, index) in serviceCategories"
                      :key="index"
                      :value="item.serviceCategoryId"
                      :label="item.label"
                    />
                  </el-select>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <base-input
                  v-uppercase
                  v-model="vendor.firstName"
                  label="First Name"
                />
              </div>
              <div class="col-md-4">
                <base-input
                  v-uppercase
                  v-model="vendor.lastName"
                  label="Last Name"
                />
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="vendor.phone"
                  label="Phone" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <base-input label="Gender">
                  <base-radio
                    v-model="vendor.gender"
                    name="male"
                  >Male</base-radio
                  >
                  <base-radio
                    v-model="vendor.gender"
                    name="female"
                  >Female</base-radio
                  >
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="vendor.email"
                  label="Email" />
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="vendor.commisionPercentage"
                  label="Commision Percentage"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <base-input label="Local Address">
                  <el-input
                    v-uppercase
                    v-model="vendor.localAddress"
                    type="textarea"
                  />
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Primary Address">
                  <el-input
                    v-uppercase
                    v-model="vendor.primaryAddress"
                    type="textarea"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <hr >
          <div class="card-header">
            <h3 class="mb-0">Advance Profile</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <base-input
                  v-model="vendor.adharCard"
                  label="Adhar Card" />
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="vendor.panCard"
                  label="Pan Card" />
              </div>
              <div class="col-md-4">
                <base-input label="Activate Vendor?">
                  <el-radio
                    v-model="vendor.isActive"
                    :label="true"
                  >Yes</el-radio
                  >
                  <el-radio
                    v-model="vendor.isActive"
                    :label="false"
                  >No</el-radio
                  >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <base-input label="Birth Date">
                  <el-date-picker
                    v-model="vendor.birthDate"
                    :picker-options="datePickerOptions"
                    type="date"
                    style="width: 100%"
                  />
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="age"
                  label="Age" />
              </div>
            </div>
          </div>
        </div>

        <base-button
          md
          type="primary"
          native-type="submit">Save</base-button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form, Input, DatePicker, Radio } from "element-ui";
import Validator from "@/plugins/customValidator";
import headerComponent from "../Components/HeaderComponent";
import dateFns from "date-fns";
export default {
  directives: {
    uppercase: {
      inserted: function (el, _, vnode) {
        el.addEventListener("input", async function (e) {
          const modified = e.target.value
            .split(" ")
            .map((i) => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      },
    },
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    "header-component": headerComponent,
    [Radio.name]: Radio,
  },
  data: () => {
    return {
      formErrors: [],
      datePickerOptions: {
        disabledDate(date) {
          return date > dateFns.subDays(new Date(), 0);
        }
      }
    };
  },

  computed: {
    ...mapState("vendor", ["vendor"]),
    ...mapGetters({
      serviceCategories: "serviceCategory/getServiceCategoryList"
    }),
    age() {
      const differenceInMonths = dateFns.differenceInCalendarMonths(
        new Date(),
        new Date(this.vendor.birthDate)
      );
      const years = parseInt(differenceInMonths / 12);
      const months = differenceInMonths % 12;
      return `${years} year/s and ${months} month/s`;
    },
  },
  mounted() {
     this.getServiceCategoryList();
    if (this.$route.params.vendorId) {
      this.getVendor(this.$route.params.vendorId);
    }
  },

  methods: {
    ...mapActions({
      saveVendor: "vendor/saveVendor",
      getVendorList: "vendor/getVendorList",
      updateVendor: "vendor/updateVendor",
      getVendor: "vendor/fetchVendor",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList"
    }),
    onSubmit() {
      if (this.vendor.vendorId) {
        this.updateVendor().then(res => {
          this.$notify({
            message: "Vendor Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getVendorList();
          this.$emit("close");
          this.$router.push("/vendors/list");
        });
      } else {
        this.saveVendor().then(res => {
          this.$notify({
            message: "Vendor Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getVendorList();
          this.$emit("close");
          this.$router.push("/vendors/list");
        });
      }
    },
    checkForm(e) {
      this.formErrors = [];
      const vendorErrors = Validator.validateVendor(this.vendor);
      this.formErrors = [...vendorErrors];
      if (!this.formErrors.length) {
        this.onSubmit();
      } else {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
      }
    }
  },
};
</script>
<style>

</style>
